import { useCallback, useContext, useEffect, useState } from 'react'

import { PatchCardResponse } from '~/modules/sales/types'
import { api } from '~/utils/api'

import { subscriptionsContext } from '../../../..'
import { UpdatePaymentCard } from './UpdatePaymentCard'

export const PaymentCard: React.FC = () => {
  const { subscription } = useContext(subscriptionsContext)
  const [cardData, setCardData] = useState<string>()

  const handleUpdate = useCallback((payload: PatchCardResponse) => {
    setCardData(payload.lastFourDigits)
  }, [])

  useEffect(() => {
    const abortController = new AbortController()
    api
      .get<PatchCardResponse>(
        `/personal-trainers/subscriptions/${subscription?.externalId}/card`,
        { signal: abortController.signal },
      )
      .then(({ data }) => {
        setCardData(data.lastFourDigits)
      })
      .catch((e) => {
        console.log(e)
      })

    return () => {
      abortController.abort()
    }
  }, [subscription])

  return (
    <div className='flex justify-between items-center p-2 rounded-lg border-2 bg-slate-50'>
      <div className='flex flex-col gap-3'>
        <p>
          Atualize aqui os dados de cobraça para um cartão novo, caso seja
          necessário.
        </p>
        <p>
          <b>Cartão atual</b>: Termina em {cardData ?? '...'}
        </p>
      </div>

      <UpdatePaymentCard onUpdate={handleUpdate} />
    </div>
  )
}
